/**
 * Transforms a version string to a short display format using first 6 characters with version prefix
 * @param version - The version ID string (e.g., "abc123def", "53", "uuid-string")
 * @returns The first 6 characters of the version ID with version prefix (e.g., "version.abc123", "version.53", "version.uuid-s")
 */
const shortVersion = (version: string): string => {
    if (!version) {
        return 'version.';
    }

    // Return first 6 characters of the version ID with version prefix
    return `version.${version.slice(0, 6)}`;
};

export default shortVersion;
